import React, { Component } from 'react';

import SocialButton from './SocialButton.js';

import { connect } from 'react-redux';

import { translate } from "react-translate";

import RegisterSocial from './RegisterSocial'

import {
    Redirect,
    withRouter,
    Link,
} from 'react-router-dom'

import {
    Button,
    Modal,
    Icon,
    Header
} from 'semantic-ui-react';

import { onSignInGG, onSignInFB } from '../../services/authService';

import { 
    addGgToken, 
    addEmail, 
    addToken, 
    addId, 
    addLanguage, 
    addModal 
} from '../../redux/actions/AppAction'


const mapStateToProps = state => ({
    app: state.app
})

const mapActionToProps = {
    addToken: addToken,
    addId: addId,
    addLanguage: addLanguage,
    addModal: addModal
}

class ConnectedSociolComponent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            error: null,
            provider: null,
            modal: false,
            email: null,
            name: null
        }

        this.onLoginSuccess = this.onLoginSuccess.bind(this);
    }

    setToken(token) {
        this.props.addToken(token)
    }

    setId(id) {
        this.props.addId(id)
    }

    setLang(lang) {
        this.props.addLanguage(lang)
    }


    addModal(value) {
        this.props.addModal(value)
    }

    onLoginSuccess(user) {
        
        if (user._provider === "google") {

            this.setState({ provider: user._provider })

            onSignInGG(user._profile.email, user._token.idToken)
                .then(res => {
                    if (res) {
                        this.setState({ redirectToReferrer: true });

                        let token = localStorage.getItem('USER_TOKEN');

                        var base64Url = token.split('.')[1];
                        var base64 = base64Url.replace('-', '+').replace('_', '/');
                        var tmp = JSON.parse(window.atob(base64));

                        let id = tmp['id'];
                        let lang = tmp['language'];

                        this.setToken(token)
                        this.setId(id)
                        this.setLang(lang)

                    }
                })
                .catch(err => {
                    this.setState({
                        error: err.code,
                        email: user._profile.email,
                        name: user._profile.name
                    })

                    this.addModal(true);
                });

        } else {

            this.setState({ provider: user._provider })

            onSignInFB(user._profile.email, user._token.accessToken)
                .then(res => {
                    if (res) {
                        this.setState({ redirectToReferrer: true });

                        let token = localStorage.getItem('USER_TOKEN');

                        var base64Url = token.split('.')[1];
                        var base64 = base64Url.replace('-', '+').replace('_', '/');
                        var tmp = JSON.parse(window.atob(base64));

                        let id = tmp['id'];
                        let lang = tmp['language'];

                        this.setToken(token)
                        this.setId(id)
                        this.setLang(lang)

                    }
                })
                .catch(err => {
                    this.setState({
                        error: err.code,
                        email: user._profile.email,
                        name: user._profile.name
                    })

                    this.addModal(true);
                });
        }
    }

    onLoginFailure(err) {
    }

    handleClose = () => {
        this.setState({ modalOpen: false, error: null })
    }

    render() {

        const { from } = { from: { pathname: "/" } };

        if (this.state.redirectToReferrer) {
            if (from === null || from.pathname === "/") {
                return <Redirect to="/homepage" />;
            }
            return <Redirect to={from} />;
        }


        const { t } = this.props;
        return (


            this.state.error ? (
                this.state.error === 302 ? (
                    <Modal  id="modalRegister" size='mini' style={{ width: '390px' }}
                        open={this.props.app.modal}
                        onClose={this.handleClose}
                        onUnmount={this.handleClose}
                    >
                        <Modal.Content style={{padding: '0'}}>
                            <RegisterSocial email={this.state.email} name={this.state.name} provider={this.state.provider} />
                        </Modal.Content>
                    </Modal>
                ) : (
                        <div>{t("error")}</div>
                    )
            ) : (
                    <div>
                        <SocialButton
                            provider='facebook'
                            appId='230922810722890'
                            onLoginSuccess={this.onLoginSuccess}
                            onLoginFailure={this.onLoginFailure}
                        >
                            <Button size='medium' fluid id="facebookBtn">
                              <Icon name='facebook f' size='large'/> {t('placeholder_fb')}
                            </Button>
                        </SocialButton>
                        <br />
                        <SocialButton
                            provider='google'
                            appId='541388613575-d2too06didb3c0ve5bubqgqtiju8qra6.apps.googleusercontent.com'
                            onLoginSuccess={this.onLoginSuccess}
                            onLoginFailure={this.onLoginFailure}
                        >
                            <Button size='medium' fluid color='red' id="googleBtn">
                              <Icon name='google plus' size='large' /> {t('placeholder_gg')}
                            </Button>
                        </SocialButton>
                    </div>
                )
        )
    }
}

const SociolComponent = connect(mapStateToProps, mapActionToProps)(ConnectedSociolComponent);
export default translate("SociolComponent")(SociolComponent);



// WEBPACK FOOTER //
// ./src/components/Login/SociolComponent.js